import { Divider, Button, Input, Modal, Switch } from 'antd';
import React, { Suspense, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';

import MyInput from '../components/Input';
import MyButton from '../components/Button';
import Typography from '../components/Typography';
import { COLORS } from '../constants/Colors';
import useIsDesktop from '../utils/hooks/useIsDesktop';
import { FormattedMessage } from 'react-intl';

const CookieSettingsModal = (props) => {
  const { isOpen, onCancle, setIsShowCookieBar, lineHeight } = props;
  // const navigate = useNavigate();

  const isDesktop = useIsDesktop();

  const [isSelectSetting1, setIsSelectSetting1] = useState(true);
  const [isSelectSetting2, setIsSelectSetting2] = useState(true);
  const [isSelectSetting3, setIsSelectSetting3] = useState(true);
  const [isSelectSetting4, setIsSelectSetting4] = useState(true);

  const onChangeSetting1 = (checked) => {
    //console.log(`onChangeSetting1 switch to ${checked}`);
    setIsSelectSetting1(checked);
  };

  const onChangeSetting2 = (checked) => {
    //console.log(`onChangeSetting2 switch to ${checked}`);
    setIsSelectSetting2(checked);
  };

  const onChangeSetting3 = (checked) => {
    //console.log(`onChangeSetting3 switch to ${checked}`);
    setIsSelectSetting3(checked);
  };

  const onChangeSetting4 = (checked) => {
    //console.log(`onChangeSetting4 switch to ${checked}`);
    setIsSelectSetting4(checked);
  };

  const onClickConfirmSettings = () => {
    const cookies = new Cookies();
    cookies.set('acceptCookie1', isSelectSetting1);
    cookies.set('acceptCookie2', isSelectSetting2);
    cookies.set('acceptCookie3', isSelectSetting3);
    cookies.set('acceptCookie4', isSelectSetting4);
    //console.log('acceptCookie1: ', cookies.get('acceptCookie1'));
    //console.log('acceptCookie2: ', cookies.get('acceptCookie2'));
    //console.log('acceptCookie3: ', cookies.get('acceptCookie3'));
    //console.log('acceptCookie4: ', cookies.get('acceptCookie4'));
    setIsShowCookieBar(false);
    onCancle();
  };

  const onClickConfirmAllSettings = () => {
    const cookies = new Cookies();
    cookies.set('acceptAllCookies', true);
    //console.log('acceptAllCookies: ', cookies.get('acceptAllCookies'));
    setIsShowCookieBar(false);
    onCancle();
  };

  return (
    <Modal
      title={
        <Typography
          color={COLORS.Primary}
          isBold
          size={isDesktop ? '40px' : '18px'}
          lineHeight={isDesktop ? '60px' : '14px'}
          className='pb-3 text-center'
        >
          <FormattedMessage id='btnCookieSettings' defaultMessage='Cookie Settings' />
        </Typography>
      }
      open={isOpen}
      onOk={() => {}}
      onCancel={onCancle}
      width={780}
      footer={[
        <MyButton className='w-35' onClick={onClickConfirmSettings}>
          <FormattedMessage id='btnConfirmSetting' defaultMessage='Confirm My Setting' />
        </MyButton>,
        <MyButton isPrimary onClick={onClickConfirmAllSettings} className='w-35'>
          <FormattedMessage id='btnAcceptAll' defaultMessage='Accept All Cookies' />
        </MyButton>,
      ]}
    >
      <Divider className='m-0' />

      <div className='d-flex flex-column px-4'>
        <Typography lineHeight='18px' className='row pt-3' isBold color={COLORS.Dark}>
          <div className='col-9'>
            <FormattedMessage id='titleStrictlyNecessary' defaultMessage='Stricly Necessary Cookies' />
          </div>
          {/* <div className='col-3'></div> */}
          <div className='col-3 text-right'>
            <Typography color={COLORS.Gray}>
              <FormattedMessage id='statusAlwaysActive' defaultMessage='Always Active' />
            </Typography>
          </div>
        </Typography>
        <Typography lineHeight='18px' className='row pt-3'>
          <div className='col-10'>
            <FormattedMessage
              id='textStrictlyNecessary'
              defaultMessage='These cookies enable you to access the information and use the website securely. They will be stored and deleted after you finish using the website.'
            />
          </div>
        </Typography>
        <Typography lineHeight='18px' className='row pt-5' isBold color={COLORS.Dark}>
          <div className='col-10'>
            {' '}
            <FormattedMessage id='titleAnalytical' defaultMessage='Analytical/Performance Cookies' />
          </div>
          {/* <div className='col-3'></div> */}
          <div className='col-2 text-right'>
            <Switch defaultChecked onChange={onChangeSetting1} />
          </div>
        </Typography>
        <Typography lineHeight='18px' className='row pt-3'>
          <div className='col-10'>
            <FormattedMessage
              id='textAnalytical'
              defaultMessage='These cookies permit us to analyze or measure the performance of the website. They collect statistical data on the way the website is accesed and on the user behavior while visiting the website by, for example, recording and counting the number of website visits in order for us to learn about your interest and behavior. The data will be used for improving the website performance and for granting easier searches to each user.'
            />
          </div>
        </Typography>
        <Typography lineHeight='18px' className='row pt-5' isBold color={COLORS.Dark}>
          <div className='col-10'>
            <FormattedMessage id='titleFunctionalityCookies' defaultMessage='Functionality Cookies' />
          </div>
          {/* <div className='col-3'></div> */}
          <div className='col-2 text-right'>
            <Switch defaultChecked onChange={onChangeSetting2} />
          </div>
        </Typography>
        <Typography lineHeight='18px' className='row pt-3'>
          <div className='col-10'>
            <FormattedMessage
              id='textFunctionalityCookies'
              defaultMessage='These cookies allow us to recognize you and provide you with more convinience next time you return to our website by recording the choices you make during your current access and website settings including remembering your user name and adjusting the font size, the language, and other features on the website as per your preferences. However, as the data to be processed in anonymized, it does not contain any information that identifies you or store any personal information.'
            />
          </div>
        </Typography>
        <Typography lineHeight='18px' className='row pt-5' isBold color={COLORS.Dark}>
          <div className='col-10'>
            <FormattedMessage id='titleTargetingCookies' defaultMessage='Targeting Cookies' />
          </div>
          {/* <div className='col-3'></div> */}
          <div className='col-2 text-right'>
            <Switch defaultChecked onChange={onChangeSetting3} />
          </div>
        </Typography>
        <Typography lineHeight='18px' className='row pt-3'>
          <div className='col-10'>
            <FormattedMessage
              id='textTargetingCookies'
              defaultMessage='These cookies record how ypu use the website, which pages you visit, and which links you click on. The collected data will be used for adjusting the website and the content displayed on the pages to better respond to your intesrest.'
            />
          </div>
        </Typography>
        <Typography lineHeight='18px' className='row pt-5' isBold color={COLORS.Dark}>
          <div className='col-10'>
            <FormattedMessage id='titleAdvertisingCookies' defaultMessage='Advertising Cookies' />
          </div>
          {/* <div className='col-3'></div> */}
          <div className='col-2 text-right'>
            <Switch defaultChecked onChange={onChangeSetting4} />
          </div>
        </Typography>
        <Typography lineHeight='18px' className='row pt-3'>
          <div className='col-10'>
            <FormattedMessage
              id='textAdvertisingCookies'
              defaultMessage='These cookies are saved on your device in order to collect data on your website access and the links you click on, allowing us to learn about your needs. The collected data will be used for improving the website and for presenting the most relavant advertisements according.'
            />
          </div>
        </Typography>
      </div>
    </Modal>
  );
};

export default CookieSettingsModal;
